import { Component, OnInit, ViewChild } from '@angular/core';
import { UserinfoService } from "../service/userinfo.service";
import { UserInfo } from "../service/Model/UserInfo";
import { TeilpaketKraft } from "../service/Model/TeilpaketKraft";
import { KraftpaketService } from "../service/kraftpaket.service";
import { MatSnackBar } from '@angular/material';
import { HistlistService } from "../service/histlist.service";
import { CsvUploadService } from '../service/csv-upload.service';
import { DataTable } from 'primeng/primeng';
import { SelectItem } from "primeng/api";
import { UserData } from '../../../config/globals/userData.global';
import { TeilpaketStatus } from './types/TeilpaketStatus';
import { UserRole } from "../type/UserRole";

// Bearbeitungsmodus der Seite
// Anzeige Teilpaketübersicht (Inhalt aus DB-Tabelle MP_ORIGIN)
// Anzeige Teilpaket-Details (csv-Datei - DB-Tabelle MP_HIST)
// Anzeige Datei-Upload
export enum PageModeEnum {
  'mpListe',
  'mpDetail',
  'mpUpload',
}

function delayFunc(t) {
  return new Promise(function(resolve) {
    setTimeout(resolve, t);
  });
}

function pollUntilDone(url, interval, timeout, appMaklerpaket, isEinspielen) {
  let start = Date.now();
  function run(appMaklerpaket:AppMaklerpaketKraft) {
    return appMaklerpaket.csvUploadService.uploadMakpakKraftCheckResult(appMaklerpaket.selectedTeilpaket, appMaklerpaket.userinfo.bensl,
      url).subscribe(function(dataResult) {
      if (JSON.stringify(dataResult).indexOf("Maklerpaket in Bearbeitung") == -1) {
        if(!appMaklerpaket.userData.isStageP()) {
          console.log("Result available :" + dataResult);
          appMaklerpaket.requestLog = JSON.stringify(dataResult).split("}}]");
          if (!appMaklerpaket.setting.element.dynamicDownload) {
            appMaklerpaket.setting.element.dynamicDownload = document.createElement('a');
          }
          const element = appMaklerpaket.setting.element.dynamicDownload;
          const fileType = 'text/json';
          element.setAttribute('href', `data:${fileType};charset=utf-8,${encodeURIComponent(appMaklerpaket.requestLog[1])}`);
          element.setAttribute('download', 'logKraft');
          var event = new MouseEvent("click");
          element.dispatchEvent(event);
          console.log("Sent");

          //rausgenommen durch p070582 - appMaklerpaket.saveCheckedJson(dataResult._body);
        }
        //Liste der Teilpakete neu laden, da sich der Status u.U. geändert hat
        if(isEinspielen){
          appMaklerpaket.loadTeilpakete(false);
          return dataResult;
        }else {
          appMaklerpaket.userData.setBiproDataLoaded(true);
          //Liste der Teilpakete neu laden, da sich der Status u.U. geändert hat
          appMaklerpaket.loadTeilpakete(false).then(() =>
            //neu laden - insbesondere damit die farbige Markierung der editierten Zellen wieder verschwindet
            appMaklerpaket.loadTeilpaketDetails(appMaklerpaket.selectedTeilpaket.id)
          );
          return dataResult;
        }

      } else {
        if (timeout !== 0 && Date.now() - start > timeout) {
          console.log("Not retrying due to timeout");
          throw new Error("timeout error on pollUntilDone");
        } else {
          console.log("Result not ready yet. Retrying soon.");
          // run again with a short delay
          return delayFunc(interval).then(run(appMaklerpaket));
        }
      }
    });
  }
  return run(appMaklerpaket);
}

@Component({
  selector: 'app-maklerpaket-kraft',
  templateUrl: './app.maklerpaket.kraft.html',
  styleUrls: ['./app.maklerpaket.kraft.scss'],
})
export class AppMaklerpaketKraft implements OnInit  {
  userinfo: UserInfo;

  //Buttonsteuerung
  id_origin : any;
  paketBearbeitungDisabled: boolean = true;
  paketBearbeitungDisabledPruefOk: boolean = true;
  paketBearbeitungDisabledInFreigabe: boolean = true;
  paketBearbeitungDisabledFreigegeben: boolean = true;
  paketLoeschenDisabled: boolean = true;
  importBtAnzeigen: boolean = false;
  loeschenBtAnzeigen: boolean = false;
  uebergabeBtAnzeigen: boolean = false;
  zuruecksendenBtAnzeigen: boolean = false;
  einspielenBtAnzeigen: boolean = false;
  ablehnenBtAnzeigen: boolean = false;
  freigebenBtAnzeigen: boolean = false;

  selectedTeilpaket: TeilpaketKraft;
  pageModes = PageModeEnum;
  mode: PageModeEnum = this.pageModes.mpListe;

  showHistList : boolean = false;
  displayDialog : boolean = false;
  deleteDialog: boolean = false;
  einspielenDialog: boolean = false;
  requestLog : any;
  statusAllList: SelectItem[];

  private _teilpakete: TeilpaketKraft[];
  private _teilpaketeMatLab: TeilpaketKraft[];
  @ViewChild(DataTable) _teilpaketDetails: DataTable;

  private readonly UserRole = UserRole; // necessary to be able use it in html-component

  setting = {
    element: {
      dynamicDownload: null as HTMLElement
    }
  }

  constructor(private userinfoService: UserinfoService,
              private kraftpakService: KraftpaketService,
              private HistListService: HistlistService,
              public csvUploadService: CsvUploadService,
              private snackBar: MatSnackBar,
              public userData : UserData) {
  }

  ngOnInit(): void {
    this.statusAllList = Object.values(TeilpaketStatus).map(val => <SelectItem> ({label: val, value: val}));

    this.userinfo = this.userinfoService.getUserinfo();
    if (this.userinfo.rolle == UserRole.MAKLER) {
      //Makler hat neben 'Teilpaket anezigen'-Button nur den Button 'Teilpaket übergeben'
      this.importBtAnzeigen = false;
      this.loeschenBtAnzeigen = true;
      this.uebergabeBtAnzeigen = true;
      this.zuruecksendenBtAnzeigen = false;
      this.einspielenBtAnzeigen = false;
      this.ablehnenBtAnzeigen = false;
      this.freigebenBtAnzeigen = false;
    }
    if (this.userinfo.rolle == UserRole.MAKLERBETREUER) {
      this.importBtAnzeigen = true;
      this.loeschenBtAnzeigen = true;
      this.uebergabeBtAnzeigen = true;
      this.zuruecksendenBtAnzeigen = false;
      this.einspielenBtAnzeigen = false;
      this.ablehnenBtAnzeigen = false;
      this.freigebenBtAnzeigen = false;
    }
    if (this.userinfo.rolle == UserRole.PRODUKTGEBER) {
      this.importBtAnzeigen = true;
      this.loeschenBtAnzeigen = false;
      this.uebergabeBtAnzeigen = false;
      this.zuruecksendenBtAnzeigen = true;
      this.einspielenBtAnzeigen = true;
      this.ablehnenBtAnzeigen = true;
      this.freigebenBtAnzeigen = true;
    }
    this.displayDialog = false;
    this.deleteDialog = false;
    this.einspielenDialog = false;
    //laden der Teilpakete
    this.loadTeilpakete(false);
    this.mode = this.pageModes.mpListe;
  }

  private errorHandling(error) {
    console.log(error);
    //reset
    this.displayDialog = false;
    this.deleteDialog = false;
    this.einspielenDialog = false;
    //laden der Teilpakete
    this.loadTeilpakete(true);
    this.mode = this.pageModes.mpListe;

  }

  labelTeilpaketeTabelleHeader: any[] = [
    {field: 'beschreibung', label: 'Paketname'},
    {field: 'dateiname', label: 'Dateiname'},
    {field: 'vermittlernummer', label: 'Vermittler-Nr'},
    {field: 'status', label: 'Status'},
    {field: 'statusdatum', label: 'Statusdatum'},
    {field: 'loeschdatum', label: 'Löschdatum'},
    {field: 'anzahlGesamt', label: 'Anzahl Vorgänge'},
    {field: 'anzahlGesperrt', label: 'Gesperrte Vorgänge'},
    {field: 'anzahlNok', label: 'Fehlerhafte Vorgänge'},
    {field: 'sumVorKh', label: 'Beitragseinnahmen KH'},
    {field: 'sumVorTk', label: 'Beitragseinnahmen TK'},
    {field: 'sumVorVk', label: 'Beitragseinnahmen VK'},
    {field: 'sumVorVuSonstige', label: 'Beitrag VorVU Sonstiges'},
    {field: 'sumVorVuInsaUnf', label: 'Beitrag VorVU Insassen-Unfall'}
  ];

  labelTeilpaketeTabelleHeaderMakler: any[] = [
    {field: 'beschreibung', label: 'Paketname'},
    {field: 'dateiname', label: 'Dateiname'},
    {field: 'vermittlernummer', label: 'Vermittler-Nr'},
    {field: 'status', label: 'Status'},
    {field: 'statusdatum', label: 'Statusdatum'},
    {field: 'loeschdatum', label: 'Löschdatum'},
    {field: 'anzahlGesamt', label: 'Anzahl Vorgänge'},
    {field: 'anzahlGesperrt', label: 'Gesperrte Vorgänge'},
    {field: 'anzahlNok', label: 'Fehlerhafte Vorgänge'}
  ];


  uploadStatus(uploadStatus: any): void {
    this.loadTeilpakete(false);
    if (uploadStatus.result.length > 0) {
      this._teilpaketDetails = uploadStatus.result;
      this.selectedTeilpaket = uploadStatus.newTeilpaket;
      this.mode = this.pageModes.mpDetail;
    } else {
      this.snackBar.open("Teilpaket-Details können nicht geladen werden!", null, {duration: 2000, panelClass: ["bgc-red-400"]});
      this.mode = this.pageModes.mpListe;
    }
  }

  anzeigeMpliste() {
    console.log("Paketübersicht anzeigen");
    this.mode = this.pageModes.mpListe;
    this._teilpaketDetails = null;
  }

  anzeigeTeilpaket() {
    if (this.selectedTeilpaket && !this.paketBearbeitungDisabled) {
      this.loadTeilpaketDetails(this.selectedTeilpaket.id);
    }
  }

  loescheTeilpaket() {
    if (this.selectedTeilpaket && !this.paketLoeschenDisabled) {
      this.deleteDialog = true;
    }
  }

  paketLoeschen() {
    this.deleteDialog = false;
    if (this.selectedTeilpaket && !this.paketLoeschenDisabled) {
      this.loescheTeilpaketAusListe(this.selectedTeilpaket.id);
    }
  }

  paketNichtLoeschen() {
    this.deleteDialog = false;
  }

  einspielenTeilpaketWithId(teilpaketId: number) {
    if (teilpaketId !== this.selectedTeilpaket.id) {
      throw new Error("Teilpaket zum einspielen ist nicht das gleiche wie das markierte.");
    }
    this.einspielenDialog = true;
  }

  einspielenTeilpaket() {
    if (this.selectedTeilpaket && !this.paketBearbeitungDisabledFreigegeben) {
      this.einspielenDialog = true;
    }
  }

  paketEinspielen() {
    this.einspielenDialog = false;
    if (this.selectedTeilpaket && !(this.paketBearbeitungDisabledFreigegeben && this.paketBearbeitungDisabledInFreigabe)) {
      this.paketAusListeEinspielen()
    }
  }

  paketNichtEinspielen() {
    this.einspielenDialog = false;
  }

  importMaklerpaket(): void {
    this.mode = this.pageModes.mpUpload;
  }

  uebergebeTeilpaket(): void {
    if (this.selectedTeilpaket && !this.paketBearbeitungDisabledPruefOk) {
      console.log("Das ausgewählte Teilpaket wird vom Makler an Produktgeber / Maklervertrieb zum Einspielen weitergeleitet!");
      this.paketUpdateStatus(TeilpaketStatus.IN_FREIGABE);
    }
  }

  freigebenTeilpaket(): void {
    if (this.selectedTeilpaket && !this.paketBearbeitungDisabledInFreigabe) {
      console.log("Das ausgewählte Teilpaket wird vom Produktgeber freigegeben!");
      this.paketUpdateStatus(TeilpaketStatus.FREIGEGEBEN);
    }
  }

  zuruecksendenTeilpaket(): void {
    if (this.selectedTeilpaket && !this.paketBearbeitungDisabledInFreigabe) {
      console.log("Das ausgewählte Teilpaket soll zur Bearbeitung zurück an den Makler!");
      this.paketUpdateStatus(TeilpaketStatus.BEARBEITET);
    }
  }

  ablehnenTeilpaket() {
    if (this.selectedTeilpaket && !this.paketBearbeitungDisabledInFreigabe) {
      console.log("Das ausgewählte Teilpaket wurde abgelehnt!");
      this.paketUpdateStatus(TeilpaketStatus.ABGELEHNT);
    }
  }

  loadHistList(event) {
    console.log("hallo - loadHistList(event) " + this.selectedTeilpaket.id);
    this.id_origin = this.selectedTeilpaket.id;
    console.log("hallo - loadHistList(event) " + this.id_origin);
    this.showHistList = true;
  }

  isHistListVisible(show: boolean) {
    this.showHistList = show;
  }

  onTeilpaketSelect(event) {
    this.kraftpakService.sendIdInUse(this.selectedTeilpaket.id)
      .subscribe((result) => {
        console.log("thank you for sending: "+result);
      },
      (error) => {
        this.snackBar.open("Fehler bei sendInUse aufgetreten!", null, {duration: 2000, panelClass: ["bgc-red-400"]});
        this.errorHandling(error);
      });
    console.log("teilpaket ausgewählt: " + this.selectedTeilpaket.id);
    this.paketBearbeitungDisabled = false;
    this.paketLoeschenDisabled = this.selectedTeilpaket.status == TeilpaketStatus.EINGESPIELT;
    this.paketBearbeitungDisabledPruefOk = this.selectedTeilpaket.status != TeilpaketStatus.GEPRUEFT_OK;
    this.paketBearbeitungDisabledInFreigabe = this.selectedTeilpaket.status != TeilpaketStatus.IN_FREIGABE;
    this.paketBearbeitungDisabledFreigegeben = this.selectedTeilpaket.status != TeilpaketStatus.FREIGEGEBEN;
  }

  onTeilpaketUnselect(event) {
    console.log("teilpaket abgewählt: " + event.data.id);
    this.paketBearbeitungDisabled = true;
    this.paketLoeschenDisabled = true;
    this.paketBearbeitungDisabledPruefOk = true;
    this.paketBearbeitungDisabledInFreigabe = true;
  }

  loadUpForCheck(packageList: any) {
    this.csvUploadService.uploadMakpakKraftForCheck(packageList, this.selectedTeilpaket, this.userinfo.bensl, '/makpak/getqoute')
      .subscribe((res) => {
        if (JSON.stringify(res).indexOf("Datei ist in Arbeit") > -1) {
          this.snackBar.open("Teilpaket wird bereits von einem anderen Anwender bearbeitet.", null, {duration: 8000, panelClass: ["bgc-red-400"]});
          this.userData.setBiproDataLoaded(true);
        } else {
          //check every 1s for up to 10 min
          pollUntilDone("/makpak/getresult", 1000, 10 * 60 * 1000, this, false);
        }
      },
      (error) => {
        this.snackBar.open("Es ist ein Fehler beim Prüfen des Teilpakets aufgetreten!", null, {duration: 2000, panelClass: ["bgc-red-400"]});
        this.errorHandling(error);
      });
  }

   loadUpForSave(packageList: any) {
     this.csvUploadService.uploadMakpakKraftForSave(packageList, this.selectedTeilpaket, this.userinfo.bensl)
      .subscribe((res) => {
        if (JSON.stringify(res).indexOf("Datei ist in Arbeit")>-1) {
          this.snackBar.open("Teilpaket wird bereits von einem anderen Anwender bearbeitet.", null, {duration: 8000, panelClass: ["bgc-red-400"]});
          this.userData.setBiproDataLoaded(true);
        } else {
          this.loadTeilpakete(false);
          this.loadTeilpaketDetails(this.selectedTeilpaket.id);
        }
        },
        (error) => {
          var errorMessageDefault = "Es ist ein Fehler beim Speichern des Teilpakets aufgetreten!";
          this.snackBar.open(errorMessageDefault, null, {duration: 3000, panelClass: ["bgc-red-400"]});
          this.errorHandling(error);
        });
  }

  async loadTeilpakete(loadInCaseOfError: boolean) {
    if (!loadInCaseOfError){
      //ToDo what is the reason of loadInCaseOfError?
    }
    //this.kraftpakService.getTeilpakete().subscribe((teilpaketeAusDB) => {
    await this.kraftpakService.getTeilpaketeFiltered()
      .then((teilpaketeAusDB) => {
          this.snackBar.open("Liste der Teilpakete wird geladen!", null, {duration: 1000, panelClass: ["bgc-green-400"]});
          this._teilpakete = teilpaketeAusDB;
        console.log("loadTeilpakete - ausgeführt");
        if (this._teilpakete.length > 0) {
          console.log("loadTeilpakete - Teilpakete gefunden");
          //das ursprüngliche wieder selektieren
          for(let teilpaket of this._teilpakete) {
            if (this.selectedTeilpaket && teilpaket.id == this.selectedTeilpaket.id) {
              this.selectedTeilpaket = teilpaket;
              this.onTeilpaketSelect(teilpaket.id);
              break;
            }
           }
          }
        }
        )
      . catch(error => {
        this.snackBar.open("Es ist ein Fehler beim Laden der Teilpakete-Liste aufgetreten!", null, {duration: 3000, panelClass: ["bgc-red-400"]});
        this.errorHandling(error);
    });
  }

  paketAusListeEinspielen() {
    console.log("Das ausgewählte Teilpaket soll über ILK eingespielt werden!");
    if (this.selectedTeilpaket && !(this.paketBearbeitungDisabledFreigegeben && this.paketBearbeitungDisabledInFreigabe)) {
      this.csvUploadService.uploadMakpakKraftForCheck(this.selectedTeilpaket.id, this.selectedTeilpaket, this.userinfo.bensl, '/makpak/setorder')
        .subscribe((res) => {
          pollUntilDone("/makpak/getresult", 1000, 10 * 60 * 1000, this, true);
         },
        (error) => {
          this.snackBar.open("Es ist ein Fehler beim Einspielen des Teilpakets aufgetreten!", null, {duration: 2000, panelClass: ["bgc-red-400"]});
          this.errorHandling(error);
         });
    }
  }

  longestValueOfCol(colName: string): number {
    let longest = -1;
    this._teilpakete.forEach(value => {
      try {
        let length = value[colName].length;
        longest = length > longest ? length : longest;
      } catch (ignored) {
      }
    });
    //let lengthHeader = colName.length;
    //(lengthHeader > longest) ? longest = lengthHeader : longest = longest;

    return longest > 100 ? 100 : longest;
  }

   loadTeilpaketDetails(teilpaketId: string) {
    //this.snackBar.open("Teilpaket wird geladen!", null, {duration: 1000, panelClass: ["bgc-green-400"]});
     this.kraftpakService.getLatestTeilpaketHist(teilpaketId)
      .subscribe((result) => {
          console.log("loadTeilpaketDetails - ausgeführt");
          if (JSON.stringify(result).length > 0) {
            if (JSON.stringify(result).indexOf("Datei ist in Arbeit") > -1) {
              this.snackBar.open("Teilpaket-Details werden bereits von einem anderen Anwender bearbeitet!", null, {duration: 8000, panelClass: ["bgc-red-400"]});
              this.userData.setBiproDataLoaded(true);
              result.splice(result.length-1, 1)
            }
            console.log("loadTeilpaketDetails - Details gefunden");
            this._teilpaketDetails = result;
            this.mode = this.pageModes.mpDetail;
          } else {
            this.snackBar.open("Teilpaket-Details können nicht geladen werden!", null, {duration: 2000, panelClass: ["bgc-red-400"]});
          }
        },
        (error) => {
          var errorMessageDefault = "Es ist ein Fehler beim Laden der Teilpaket-Details aufgetreten!";
          try {
            var errorMessageBackend = JSON.parse(error._body).Message.string;
            if (errorMessageBackend)
              errorMessageDefault = errorMessageDefault + " " + errorMessageBackend;
          }
          catch (e) {
            console.log(e);
          }
          this.snackBar.open(errorMessageDefault, null, {duration: 3000, panelClass: ["bgc-red-400"]});
          this.errorHandling(error);
        });
  }

  private loescheTeilpaketAusListe(teilpaketId: string) {
    console.log("wir löschen jetzt " + teilpaketId);
    this.kraftpakService.deleteTeilPaket(teilpaketId)
      .subscribe((result) => {
        if (result != null) {
          this.paketBearbeitungDisabled = true;
          this.paketLoeschenDisabled = true;
          this.paketBearbeitungDisabledPruefOk = true;
          this.paketBearbeitungDisabledInFreigabe = true;
          this.paketBearbeitungDisabledFreigegeben = true;
          this.loadTeilpakete(false);
          this.selectedTeilpaket = null;
        }
        },
        (error) => {
          var errorMessageDefault = "Es ist ein Fehler beim Löschen des Teilpakets aufgetreten!";
          try {
            var errorMessageBackend = JSON.parse(error._body).Message.string;
            if (errorMessageBackend)
              errorMessageDefault = errorMessageDefault + " " + errorMessageBackend;
          }
          catch (e) {
            console.log(e);
          }
          this.snackBar.open(errorMessageDefault, null, {duration: 3000, panelClass: ["bgc-red-400"]});
          this.errorHandling(error);
        });
  }

  changeDone(elementid: string) {
    if (!document.getElementById(elementid).classList.contains("ng-invalid")) {
      this.displayDialog = true;
    }
  }

  paketNichtSpeichern() {
    this.displayDialog = false;
    this.paketBearbeitungDisabled = true;
    this.paketLoeschenDisabled = true;
    this.paketBearbeitungDisabledPruefOk = true;
    this.paketBearbeitungDisabledInFreigabe = true;
    this.paketBearbeitungDisabledFreigegeben = true;
    this.loadTeilpakete(false);
    //this.selectedTeilpaket = null;
  }

  paketSpeichern() {
    console.log("Speichern der Änderungen für Paket " + this.selectedTeilpaket.id);
    this.kraftpakService.updateTeilpaket(this.selectedTeilpaket)
      .subscribe((result) => {
        if (result != null) {
          this.paketBearbeitungDisabled = true;
          this.paketLoeschenDisabled = true;
          this.paketBearbeitungDisabledPruefOk = true;
          this.paketBearbeitungDisabledInFreigabe= true;
          this.paketBearbeitungDisabledFreigegeben = true;
          this.loadTeilpakete(false);
          //this.selectedTeilpaket = null;
          this.displayDialog = false;
          }
        },
       (error) => {
          var errorMessageDefault = "Es ist ein Fehler beim Speichern der geänderten Paketinformationen aufgetreten!"
          try {
            var errorMessageBackend = JSON.parse(error._body).Message.string;
            if (errorMessageBackend)
              errorMessageDefault = errorMessageDefault + " " + errorMessageBackend;
          }
          catch (e) {
            console.log(e);
          }
          this.snackBar.open(errorMessageDefault, null, {duration: 3000, panelClass: ["bgc-red-400"]});
          this.errorHandling(error);
        });
  }

  paketUpdateStatus(status: string) {
    this.kraftpakService.updateTeilpaketStatus(this.selectedTeilpaket.id, status, this.userinfo.bensl)
      .subscribe((result) => {
        if (result != null) {
          this.paketBearbeitungDisabled = true;
          this.paketLoeschenDisabled = true;
          this.paketBearbeitungDisabledPruefOk = true;
          this.paketBearbeitungDisabledInFreigabe = true;
          this.paketBearbeitungDisabledFreigegeben = true;
          this.loadTeilpakete(false);
          //this.selectedTeilpaket = null;
          this.displayDialog = false;
        }
       },
      (error) => {
          var errorMessageDefault = "Es ist ein Fehler beim Aktualisieren des Teilpaket-Status aufgetreten!";
          try {
            var errorMessageBackend = JSON.parse(error._body).Message.string;
            if (errorMessageBackend)
              errorMessageDefault = errorMessageDefault + " " + errorMessageBackend;
          }
          catch (e) {
            console.log(e);
          }
          this.snackBar.open(errorMessageDefault, null, {duration: 3000, panelClass: ["bgc-red-400"]});
          this.errorHandling(error);
        });
  }


}
